import { Environment } from './environment.interface'

export const environment: Environment = {
    production: false,
    API_URL: '/api',
    REV_URL: '/I',
    VERSION: '2024.C',
    VERSION_URL: '/v1',
    BUILD_FOR_BROWSER: true,
    BUILD_FOR_MOBILE: false,
    DEVELOPMENT_BUILD: false,
    ENVIRONMENT: 'TEST',
    awsCognito: {
        domain: 'timesheets.auth.eu-west-1.amazoncognito.com',
        region: 'eu-west-1',
        userPoolId: 'eu-west-1_Hy7YrNgk7',
        userPoolWebClientId: '5l0vj3i1rbf14smpn8g3siunnj'
    }
}
